module.exports = __webpack_public_path__ + "static/media/visibilityOn.f09c4d00.svg";